import { useMemo } from 'react';

import { groupMatchesByDate } from 'widgets/fixtures/js/utils/group-matches-by-date';
import { groupMatchesByRoundName } from 'widgets/fixtures/js/utils/group-matches-by-roundName';

const FLATTEN_DEPTH = 4;

/**
 * @param {Array} data the matches data array.
 * @param {string} timezone the timezone string.
 * @returns {Array} matchItems
 */
export const useGroupMatches = (data, timezone) => {
    /**
     * (1) Groups Fixtures first by their date or a generic TBCPC if they are
     * cancelled/TBC/postponded
     * (2) Then goes through each date in the grouped object and for each day
     * groups the matches by round name and then converts that object into an
     * array, e.g. ['Round 1', {match}, 'Round 2', {match}]
     * (3) Takes the complete object converts it to an array and flattens it
     * completely so we end up with something like this:
     * ["20240314", "Round 1", {match}, "20240315" ... etc]
     */
    const matchItems = useMemo(() => {
        // Group results based on start day/month
        if (data) {
            // (1)
            const groupedByDate = groupMatchesByDate(data, timezone);

            // (2)
            for (const date in groupedByDate) {
                if (Object.prototype.hasOwnProperty.call(groupedByDate, date)) {
                    const groupedByRoundName = groupMatchesByRoundName(
                        groupedByDate[date]
                    );
                    groupedByDate[date] = Object.entries(groupedByRoundName);
                }
            }

            // (3)
            return Object.entries(groupedByDate).flat(FLATTEN_DEPTH);
        }

        return [];
    }, [data, timezone]);

    return matchItems;
};
